import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.nivelaeducacao.com.br";

interface PageSeoProps {
  title: string;
  description?: string;
  path?: string;
  noindex?: boolean;
  ogType?: "website" | "article";
  image?: string;
  imageWidth?: number;
  imageHeight?: number;
}

/**
 * Per-route SEO metadata. Overrides the static tags in index.html
 * for crawlers that execute JS (Googlebot). Social-preview crawlers
 * (LinkedIn, Slack, Facebook) still see the index.html fallback.
 */
export function PageSeo({
  title,
  description,
  path = "/",
  noindex = false,
  ogType = "website",
  image,
  imageWidth = 1536,
  imageHeight = 864,
}: PageSeoProps) {
  const url = `${SITE_URL}${path}`;
  const absoluteImage = image
    ? image.startsWith("http")
      ? image
      : `${SITE_URL}${image.startsWith("/") ? "" : "/"}${image}`
    : undefined;
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {noindex ? (
        <meta name="robots" content="noindex,nofollow" />
      ) : (
        <link rel="canonical" href={url} />
      )}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      {absoluteImage && <meta property="og:image" content={absoluteImage} />}
      {absoluteImage && <meta property="og:image:width" content={String(imageWidth)} />}
      {absoluteImage && <meta property="og:image:height" content={String(imageHeight)} />}
      <meta name="twitter:card" content={absoluteImage ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      {absoluteImage && <meta name="twitter:image" content={absoluteImage} />}
    </Helmet>
  );
}
